<template>
  <div class="XVsterrencontrol">
      <div class="starholder pointer">
      <div  class="ie11gridhack" v-for="(listitem,index) in datalist" :key="index" @mouseover="overradio(listitem.value,index)" @mouseleave="leaveradio(listitem.value,index)" @click.prevent="clickradio(listitem.value,index)" >


              <div class="ie11gridhack"> 
              <font-awesome-layers class="fa-2x" >
                <font-awesome-icon class="star"   :icon="['fas', 'star']" v-if="hoverindex == -1 && index <= sindex || hoverindex != -1 && index <= hoverindex  "  />
                <!-- <font-awesome-icon class="star star-trans"   :icon="['fas', 'star']" v-if="index <= hoverindex"  />    -->
                
                <font-awesome-icon class="star"   :icon="['far', 'star']" />

                <span class="fa-layers-text" >
                  <FontAwesomeLayersText class="startext" transform="shrink-10 right-1 down-1"   ></FontAwesomeLayersText>
                </span>      
                                       
              </font-awesome-layers> 
              </div>
              
      </div>
      <div></div>
      </div>


  </div>
</template>

<script>
import { FAMixin } from 'pevueglobal'
export default {
  name: 'XVsterrencontrol',
  mixins: [FAMixin],
  props: {
      focus: {
        type: Boolean,
        default: false
      },
      id: {
        type: String,
        required: true
      },
      datalist: {
        type: Array,
        required: true
      },
      value: {
        type: String,
        default: ''
      },
      formdata: {},
      disabled: {
        type: Boolean,
        default: false
      }

  },
   data() {
    return {
      hoverindex: -1,
      rollovertimeout: false
    }
  },
  computed: {
    sindex: function(){
      let i = 0
      let sel = 0      
      this.datalist.forEach(e => {
        // console.log(e.value)

        if (String(e.value) === this.value){
          sel = i
          console.log(e.value)
          console.log(this.value)          
        }
        i++
      })
      // if (this.hoverindex !== null && this.rollovertimeout === false){
      //  return this.hoverindex
      // } else {
        return sel
      // }
      
    }
  },
  methods: {
    overradio: function(val,starindex){
      this.hoverindex = starindex
    },
    leaveradio: function(val,starindex){
      this.hoverindex = -1
    },
    clickradio: function(val,starindex){
      
     
      // this.sindex = starindex
      if (this.disabled === true){
        return false
      }
      this.$emit('input', String(val)) // prop value en deze input event handler zorgen er voor dat je een v-model kan toepassen op dit custom component
      this.$emit('formvaluechanged',
        {
          type: this.$vnode.componentOptions.tag,
          value: val,
          id: this.id,
          formdata: this.formdata
        }
      )
    }
  }
}
</script>
